export const LoadingScreen = () => {
  const letters = "FINO".split("");

  return (
    <div className="min-h-screen flex flex-col items-center justify-center overflow-hidden relative bg-gradient-to-br from-black via-slate-950 to-slate-900">
      {/* Floating background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full blur-3xl animate-pulse bg-emerald-500/20"></div>
        <div className="absolute bottom-1/3 right-1/4 w-40 h-40 rounded-full blur-3xl animate-pulse bg-emerald-500/20" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 right-1/3 w-24 h-24 rounded-full blur-2xl animate-pulse bg-emerald-500/20" style={{ animationDelay: '0.5s' }}></div>
      </div>
      
      {/* Animated FINO Logo */}
      <div className="relative z-10 mb-8">
        <div className="flex gap-2">
          {letters.map((letter, index) => (
            <span
              key={index}
              className="text-6xl md:text-8xl font-bold animate-letter-bounce bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 via-emerald-500 to-green-500"
              style={{
                animationDelay: `${index * 0.1}s`,
                backgroundSize: "200% auto",
                animation: `letterBounce 1s ease-in-out ${index * 0.1}s both, gradientShift 3s ease infinite`,
              }}
            >
              {letter}
            </span>
          ))}
        </div>
      </div>
      
      {/* Spinning gradient ring */}
      <div className="relative mb-6">
        <div className="animate-spin rounded-full h-20 w-20 border-4 border-transparent bg-clip-padding bg-gradient-to-r from-emerald-500 via-green-500 to-emerald-600"></div>
        <div className="absolute inset-0 m-1 rounded-full bg-slate-900"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 rounded-full animate-pulse bg-emerald-400"></div>
        </div>
      </div>
      
      {/* Loading text with playful animation */}
      <div className="relative z-10 text-center">
        <p className="text-xl font-semibold mb-2 animate-fade-in text-gray-100">
          Getting things ready
        </p>
        <p className="text-sm animate-pulse text-gray-400">
          Just a moment...
        </p>
      </div>
    </div>
  );
};
